var _path, _polygon, _polyline, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconReset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-stroke",
    d: "m33.57,53.42c11.83,0,21.42-9.59,21.42-21.42s-9.59-21.42-21.42-21.42-21.42,9.59-21.42,21.42",
    fill: "none",
    strokeWidth: "5.09px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "wasm-icon-fill wasm-icon-stroke",
    points: "13.13 44.79 22.26 31.68 3 32.44 13.13 44.79",
    strokeWidth: "1.21px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "wasm-icon-stroke",
    points: "33.57 22.84 33.57 32 39.36 36.66",
    fill: "none",
    strokeWidth: "3.82px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 12.15,
    y1: 32,
    x2: 12.15,
    y2: 32,
    fill: "none",
    strokeWidth: "5.09px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-stroke",
    d: "m13.78,40.2c2.7,6.52,8.53,11.41,15.61,12.81",
    fill: "none",
    strokeDasharray: "0 0 0 8.41",
    strokeWidth: "5.09px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 33.57,
    y1: 53.42,
    x2: 33.57,
    y2: 53.42,
    fill: "none",
    strokeWidth: "5.09px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconReset3);
export default __webpack_public_path__ + "static/media/SDS_icon_Reset_3.5602edb52e7152ef7931a68113f714f5.svg";
export { ForwardRef as ReactComponent };